module.exports = __webpack_public_path__ + "static/media/approve.b6cf9707.svg";